'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _domUtils = require('../utils/dom-utils');

var _utils = require('../utils/utils');

var _cssClasses = require('../constants/css-classes');

var cssClasses = _interopRequireWildcard(_cssClasses);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getCssClasses(id) {
  var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return [cssClasses.FORM_FLOATING_ALERT, cssClasses.FORM_FLOATING_ALERT + '-' + id, isError && cssClasses.FORM_FLOATING_ALERT_ERROR].filter(Boolean);
}

function getWrapperCssClasses(id) {
  return [cssClasses.FORM_FLOATING_ALERT_WRAPPER, cssClasses.FORM_FLOATING_ALERT_WRAPPER + '-' + id];
}

var HIDE_TIMEOUT = 10 * 1000;

function HTMLContent(id, message) {
  var isError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return '\n<div class="' + getWrapperCssClasses(id).join(' ') + '">\n  <div class="' + getCssClasses(id, isError).join(' ') + '">\n    <div class="' + cssClasses.FORM_FLOATING_ALERT_CLOSE_BUTTON + '">&#x2716</div>\n    ' + message + '\n  </div>\n</div>';
}

var Notification = function () {
  function Notification(_ref) {
    var container = _ref.container;

    _classCallCheck(this, Notification);

    this.container = container;
    this.timeouts = {};

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.showError = this.showError.bind(this);
  }

  _createClass(Notification, [{
    key: 'show',
    value: function show(id, message, isError) {
      var html = HTMLContent(id, message, isError);
      var wrapperElement = (0, _domUtils.createElementFromHTML)(html);
      this.container.insertBefore(wrapperElement, this.container.firstChild);
      document.querySelector('.' + cssClasses.FORM_FLOATING_ALERT_CLOSE_BUTTON).addEventListener('click', this.hide.bind(this, id));

      this.timeouts[id] = setTimeout(this.hide.bind(this, id), HIDE_TIMEOUT);
      setTimeout(function () {
        return wrapperElement.classList.add(cssClasses.FORM_FLOATING_ALERT_WRAPPER_OPENED);
      }, 10);
    }
  }, {
    key: 'showError',
    value: function showError(id, message) {
      this.show(id, message, true);
    }
  }, {
    key: 'hide',
    value: function hide(id) {
      var _this = this;

      var selector = getWrapperCssClasses(id).map(function (className) {
        return '.' + className;
      }).join('');
      var wrapperElement = document.querySelector(selector, this.container);
      if ((0, _utils.isDOMNode)(wrapperElement)) {
        clearTimeout(this.timeouts[id]);
        wrapperElement.classList.remove(cssClasses.FORM_FLOATING_ALERT_WRAPPER_OPENED);
        wrapperElement.addEventListener('transitionend', function () {
          _this.container.removeChild(wrapperElement);
        });
      }
    }
  }]);

  return Notification;
}();

exports.default = Notification;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/validation/Notification.js
// module id = 5
// module chunks = 0 1 2 3